import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash';
import Dimensions from 'react-dimensions';
import { withStyles } from '@material-ui/styles';
import NoResultCard from 'components/base/NoResultCard';
import { connect } from 'react-redux';
import { getInfluencerTopPost } from 'redux/influencers/actions';
import { Typography } from '@material-ui/core';
import Force from 'components/base/charts/Force';
import FooterSpace from 'components/common/FooterSpace';
import Posts from '../Posts';
import styles from './styles';

class TopLabels extends Component {
  handleClick = (label) => {
    const { influencerProfile } = this.props;
    this.props.getInfluencerTopPost(influencerProfile.data.id, { label });
  }

  render() {
    const {
      labels,
      containerWidth,
      classes,
      theme,
      influencerTopPosts: { posts, loading },
    } = this.props;
    return (
      <div>
        {isEmpty(labels) && <NoResultCard noResultMessage="No label data." />}
        {!isEmpty(labels) &&
          <React.Fragment>
            <div className={classes.bubble__container}>
              <Typography variant="h5">Labels</Typography>
              <Force
                data={{
                  nodes: labels.map(d => ({ label: d.text, value: d.count })),
                  links: [],
                }}
                width={containerWidth}
                height={300}
                onSelectNode={node => this.handleClick(node.label)}
                nodeColor={theme.palette.blue.main}
              />
            </div>
            <div>
              <Typography variant="h5">Posts</Typography>
              <Posts posts={posts} loading={loading} />
            </div>
            <FooterSpace />
          </React.Fragment>
        }
      </div>
    );
  }
}

TopLabels.propTypes = {
  classes: PropTypes.shape({}).isRequired,
  theme: PropTypes.shape({}).isRequired,
  labels: PropTypes.arrayOf(PropTypes.shape({
    text: PropTypes.string,
    count: PropTypes.number,
  })).isRequired,
  influencerProfile: PropTypes.shape({
    data: PropTypes.shape({
      id: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
  influencerTopPosts: PropTypes.shape({}),
  containerWidth: PropTypes.number.isRequired,
  getInfluencerTopPost: PropTypes.func.isRequired,
};

TopLabels.defaultProps = {
  influencerTopPosts: {},
};

export default connect(
  state => ({
    influencerProfile: state.influencerProfile,
    influencerTopPosts: state.influencerTopPosts,
  }),
  { getInfluencerTopPost },
)(Dimensions()(withStyles(styles, { withTheme: true })(TopLabels)));
